import { PeriodType } from '@anytag/shared-types';
import { formatDate } from '@anytag/shared-utils';

export const formatAffiliatePeriod = ({ period, title }: { period: Partial<PeriodType>; title: string }) =>
  `${title}\u00A0\u00A0(${formatDate(period.startDate || '')} - ${formatDate(period.endDate || '')})`;
